export namespace OperatingScheduleConstants {
  export const SUNDAY = 'Sunday';
  export const MONDAY = 'Monday';
  export const TUESDAY = 'Tuesday';
  export const WEDNESDAY = 'Wednesday';
  export const THURSDAY = 'Thursday';
  export const FRIDAY = 'Friday';
  export const SATURDAY = 'Saturday';

  export enum DAYS_OF_THE_WEEK {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday
  }
}
